import React, { useEffect, useState } from "react";
import {
  AVTAR_IMG,
  LOGOUTICON,
  PROFILE_ICON,
  TOGGLELEFTARROW,
  WHITEBGDOWNARROW_IMG,
} from "../../../utills/image-constant";
import { useDispatch, useSelector } from "react-redux";
import { clearloggedEmployeeReducer } from "../../../admin/hooks/redux/slice/logged-employee";
import { clearemployeeAccessTokenTokenReducer } from "../../../admin/hooks/redux/slice/employee-access-token";
import { getAllAnswerByEmpId, getCriteriaByModelId, userLogout } from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import { USERROUTES } from "../../routes/url-constant";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const Leftbar = ({ pageName = "", }) => {
  const parsedEmployeeData = useSelector((state) => state?.loggedEmployee?.value);
  const Token = useSelector((state) => state?.employeeAccessToken?.value);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      const response = await userLogout(Token);
      if (response?.status === 200) {
        toastEmitter("success", "User Logout Successfully");
        dispatch(clearloggedEmployeeReducer())
        dispatch(clearemployeeAccessTokenTokenReducer())
        navigate(USERROUTES.USERLOGIN);
      }
    } catch (err) {
      console.error("Error fetching role data", err);
    }
  };


  return (
    <div className="Quiz_leftbar">
      <div className="card text-white">
        {pageName == "UserTestIntro" && <div className="card_topsec text-center">
          <img src={parsedEmployeeData?.image ? parsedEmployeeData?.image : AVTAR_IMG} class="card-img-top mb-3" alt="PROFILE_IMG" />
          <div class="dropdown profiledropdown">
            <img
              src={WHITEBGDOWNARROW_IMG}
              className="card-img mb-3 btn btn-secondary dropdown-toggle "
              type="button"
              id="dropdownMenu2"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              alt=""
            />
            <div
              class="dropdown-menu mt-3 px-3 py-2 rounded-4 border-0 shadow-lg profile-dropdown"
              aria-labelledby="dropdownMenu2"
            >
              <div className="cursor-pointer">
                <img className="cursor-pointer" src={PROFILE_ICON} alt="" />
                <span className="ms-2 " onClick={() => navigate(USERROUTES.USERPROFILE)}>My Profile</span>
              </div>
              <hr className="mt-2 mb-1" />
              <div className="cursor-pointer" onClick={handleLogout}>
                <img className="cursor-pointer" src={LOGOUTICON} alt="" />
                <span className="ms-2">Logout</span>
              </div>
            </div>
          </div>
          <h5 className="card-subtitle">{parsedEmployeeData?.employeeName}</h5>
        </div>}
        <div className="card-body">
          <div className="row">
            <div className="col-10">
              <h2 className="card-title">Caspera.Lab</h2>
              <h5 className="card-subtitle my-3">Welcome to the assessment exercise.</h5>
            </div>
            {pageName == "userTest" && <div className="col-2">
              <img src={TOGGLELEFTARROW} alt="" className="toggle-left-arrow" onClick={() => navigate(USERROUTES.USERPROFILEINTRODUCTION)} />
            </div>}
          </div>
          {pageName == "UserTestIntro" && <p className="card-text mb-3">
            <p>You have been selected to participate to this campaign for your enterprise. Thanks for your inputs​ ​</p>
          </p>}
          {/* {
            pageName == "userTest" && <div className="row">
              <div className="d-flex"><div className="d-flex">Total Questions <div className="light-div  mt-2 ms-2"></div></div><div className="d-flex ms-4">Total Questions Done <div className="green-div mt-2 ms-2"></div></div></div>
              <div className="mt-3"><p>Total Questions - {questionList?.length} </p><p>Total Questions Done - {data?.criteriaQuestionList?.length}</p></div>
              <div className="question-sec">
                <div className="row">
                  {questionList &&
                    questionList.map((v, i) => {
                      const isSelected = data?.criteriaQuestionList?.some((w) => w?.criteriaId === v?.id);
                      return (
                        <div className="col-2" key={v.id || i}>
                          <button
                            className={`mt-3 ${isSelected
                              ? "qus-btn-green"
                              : currentQuestionIndex === i
                                ? "Cqus-btn"
                                : "qus-btn"
                              }`}
                            onClick={() => {
                              handleindex(v, i)
                            }}
                          >
                            {i + 1}
                          </button>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          } */}
        </div>
      </div>
    </div>
  );
};

export default Leftbar;
